import React, { useState, useEffect } from "react";

// Components
import Sidebar from "../../components/Sidebar";
import Main from "./ProductReceipt/Main";
import Form from "./ProductReceipt/Form";

import {
  getDataWithComp,
  getDocStatusColour,
  getAlert,
  getMaxRecNo,
} from "../../../utils/SamuiUtils";

import { getReport } from "../../../utils/ReportUtils";
import Navbar from "../../components/Modal/Navbar";

function ProductReceipt() {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  const [statusColours, setStatusColours] = useState([]);
  const [maxRecNo, setMaxRecNo] = useState();
  const [initData, setInitData] = useState({ timestamp: Date.now() }); // ✅ เพิ่ม state สำหรับ trigger การ refresh

  useEffect(() => {
    initialize();
  }, []);

  const fetchRealtime = async () => {
    try {
      const masterList = await getDataWithComp(
        "API_0301_REC_H",
        "ORDER BY Rec_No DESC"
      );

      // const detailList = await getDataWithComp('API_0302_REC_D', '');
      const docStatusColour = await getDocStatusColour("POREC", "Rec_Status");

      if (masterList && masterList.length > 0) {
        const sortedData = masterList.sort((a, b) => a.Rec_No - b.Rec_No);
        setDataMasterList(sortedData);
      }

      if (docStatusColour && docStatusColour.length > 0) {
        setStatusColours(docStatusColour);
      }

      // หาค่าสูงของ RecNo ใน REC_H
      const findMaxRecNo = await getDataWithComp(
        "REC_H",
        "ORDER BY Rec_No DESC"
      );
      const maxRec = getMaxRecNo(findMaxRecNo);
      setMaxRecNo(maxRec);
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const initialize = async () => {
    try {
      setMode("S");
      await fetchRealtime(); // ✅ เพิ่ม await เพื่อให้รอข้อมูลโหลดเสร็จ
      setInitData({ timestamp: Date.now() }); // ✅ อัพเดท timestamp เพื่อ trigger useEffect ใน Form
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const onPageInsert = () => {
    setMode("I");
    // ✅ รีเซ็ต maxRecNo เมื่อสร้างใหม่
    const findMaxRecNo = async () => {
      try {
        const findMax = await getDataWithComp("REC_H", "ORDER BY Rec_No DESC");
        const maxRec = getMaxRecNo(findMax);
        setMaxRecNo(maxRec);
        setInitData({ timestamp: Date.now() }); // ✅ อัพเดท timestamp
      } catch (error) {
        console.error("Error finding max RecNo:", error);
      }
    };
    findMaxRecNo();
  };

  const onRowSelected = (recNo) => {
    setMaxRecNo(recNo);
    setMode("U");
    setInitData({ timestamp: Date.now() }); // ✅ อัพเดท timestamp เมื่อเลือกแถว
  };

  return (
    <div className="PurchaseOrder">
      <div className="wrapper">
        <Navbar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              {mode === "S" ? (
                <Main
                  masterList={dataMasterList}
                  statusColours={statusColours}
                  name={"ใบรับสินค้า"}
                  onPageInsert={() => onPageInsert()}
                  onRowSelected={(recNo) => onRowSelected(recNo)}
                  getReport={getReport}
                />
              ) : (
                <Form
                  callInitialize={initialize}
                  mode={mode}
                  name={"ใบรับสินค้า"}
                  maxRecNo={maxRecNo}
                  getReport={getReport}
                  initData={initData} // ✅ ส่ง initData ไปด้วย
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductReceipt;
